import {
  addDoc,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';
import { getFirestoreDb } from '../config';
import type { RoomLogEntry } from '../../../types/room';
import { LOGS_COLLECTION, ROOMS_COLLECTION } from './constants';

/**
 * Logs a room entry/exit event.
 */
export async function logRoomActivity(
  roomId: string,
  userId: string,
  userName: string,
  action: 'entered' | 'left'
): Promise<void> {
  const db = getFirestoreDb();
  const logsRef = collection(db, ROOMS_COLLECTION, roomId, LOGS_COLLECTION);

  await addDoc(logsRef, {
    userId,
    userName,
    action,
    timestamp: serverTimestamp(),
  });
}

/**
 * Gets the activity log for a room.
 */
export async function getRoomActivityLog(
  roomId: string,
  maxEntries = 100
): Promise<RoomLogEntry[]> {
  const db = getFirestoreDb();
  const logsRef = collection(db, ROOMS_COLLECTION, roomId, LOGS_COLLECTION);
  const queryRef = query(logsRef, orderBy('timestamp', 'desc'), limit(maxEntries));

  const snapshot = await getDocs(queryRef);
  return snapshot.docs.map((docSnap) => {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      userId: data.userId,
      userName: data.userName,
      action: data.action,
      timestamp: data.timestamp?.toDate() || new Date(),
    } as RoomLogEntry;
  });
}
